import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AutenticationService } from '../autentication.service';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { AutenticationEventType } from '../autentication.event.type';
import { TweenMax, Quint } from 'gsap';
import { Auth } from '../Auth';
import { EventTypes } from '../../shared/EventTypes';
import { Sms } from '../models/sms';
import { AuthMessage } from '../models/auth-message';

@Component({
	selector: 'app-token-validation',
	templateUrl: './token-validation.component.html',
	styleUrls: ['./token-validation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TokenValidationComponent implements OnInit, OnDestroy {

	view = '[data-component="token-validation"]';
	active = false;

	activeInput: any;
	activeInputIndex = 0;
	tokenCode = '';
	loading = false;
	sendCodeLoading = false;
	validationError = false;
	canSend = false;
	codeSize = 6;
	passwordToSend: string;
	disabled = false;

	constructor(private authService: AutenticationService) {

	}

	ngOnInit() {

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.TOKEN_VALIDATION, data => {
			if (data.show) {
				this.active = true;

				this.passwordToSend = data.passwordToSend;

				const interval = setInterval(() => {
					if ($(this.view).length > 0) {
						this.show(data);
						clearInterval(interval);
					}
				}, 10);

			}
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.TOKEN_VALIDATION);
	}

	show(data) {

		$('#tokenCode').pincodeInput({inputs: this.codeSize, hidedigits: false,
		complete: (value, e, errorElement) => {
			this.pinComplete();
		}});

		this.activeInput = $('.pincode-input-text.first');

		$('.pincode-input-text').keydown( () => {

			return false;

		});

		TweenMax.to(this.view, .8, {delay: data.delay, left: 0, ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to(this.view, .8, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	pinComplete() {
		// alert(' PIN COMPLETE');
	}

	getKeyboardValue(value) {

		if (this.activeInputIndex <= (this.codeSize - 1)) {
			this.activeInput.val(value[0]);
			this.activeInputIndex++;
			this.activeInput = $($('.pincode-input-text')[this.activeInputIndex]);
			this.activeInput.focus();

			if (this.activeInputIndex > (this.codeSize - 1)) {
				this.canSend = true;
			}
		}
	}

	clearInputs() {
		$('.pincode-input-text').val('');
		$('.pincode-input-text.first').focus();
		this.activeInputIndex = 0;
		this.activeInput = $('.pincode-input-text.first');
		this.canSend = false;
	}

	send() {

		if (this.canSend) {
			this.tokenCode = '';
			const self = this;
			this.disabled = true;

			$('.pincode-input-text').each(function() {
				self.tokenCode += $(this).val();
			});

			if (!this.loading && (this.tokenCode.length === this.codeSize)) {
				this.loading = true;
				this.validationError = false;

				this.authService.sendTokenCode(Auth.cpf, this.tokenCode, this.passwordToSend).subscribe( data => {

					this.canSend = false;
					this.loading = false;
					this.disabled = false;
					this.hide();

					const message = new AuthMessage();
					message.buttonTitle = 'Acessar';
					message.delay = .2;
					message.eventToDispatch = AutenticationEventType.LOGIN.MY_CPF;
					message.eventData = { fromDefinePassword: true };
					message.delayToDispatchEvent = .8;
					message.hasButton = true;
					message.title = 'Sua senha foi redefinida com sucesso!';
					message.text = 'A partir de agora, está será a sua nova senha para acessar a sua conta.';
					message.withPreload = false;

					AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);

				}, error => {

					this.loading = false;
					this.disabled = false;
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });

				});
			} else if (this.tokenCode.length !== this.codeSize) {
				this.validationError = true;
				this.disabled = false;
			}
		}

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/token-validation/token-validation.component.ts